import { createEventTracker } from '../util';
import {
  MetricAddToDashboardAnalytics,
  MetricViewedAnalytics,
  MetricArchivedAnalytics,
  MetricExploredAnalytics,
  MetricSavedAnalytics,
  MetricSessionWatchedAnalytics,
} from './types';

export const trackMetricViewed = createEventTracker<MetricViewedAnalytics>('Metric Viewed');
export const trackMetricSaved = createEventTracker<MetricSavedAnalytics>('Metric Saved');
export const trackMetricArchived = createEventTracker<MetricArchivedAnalytics>('Metric Archived');
export const trackMetricSessionWatched =
  createEventTracker<MetricSessionWatchedAnalytics>('Metric Session Watched');
export const trackMetricExplored = createEventTracker<MetricExploredAnalytics>('Metric Explored');
export const trackMetricAddToDashboard =
  createEventTracker<MetricAddToDashboardAnalytics>('Metric Add To Dashboard');
